import TripFormModalView from './trip_form_modal_view'

export default class TripFormView {
  constructor() {
    this.events = []

    this.observeCompanyCreateClick()
    this.observeDriverCreateClick()
  }

  observeCompanyCreateClick() {
    $('form.trip').on('click', 'button.new_company', (event) => {
      console.log("New Company button was clicked!")
      const href = $(event.currentTarget).attr('href')

      this.modalView = new TripFormModalView({
        parentView:       this,
        url:              href,
        title:            "Add New Company",
        submitButtonText: "Create Detail",
      })
    })
  }

  observeDriverCreateClick() {
    $('form.trip').on('click', 'button.new_driver', (event) => {
      console.log("New Driver button was clicked!")
      const href = $(event.currentTarget).attr('href')

      this.modalView = new TripFormModalView({
        parentView:       this,
        url:              href,
        title:            "Add New Driver",
        submitButtonText: "Create Driver",
      })
    })
  }
}
